import * as types from './actionTypes';

/**
 * Set apiUrl
 */
export const setApiUrlDomain = apiUrl => ({
  type: types.SET_API_URL_DOMAIN,
  payload: {
    apiUrl,
  },
});

/**
 * Set token
 */
export const setToken = token => ({
  type: types.SET_TOKEN,
  payload: {
    token,
  },
});

/**
 * Set chat config
 */
export const setChatConfig = config => ({
  type: types.SET_CHAT_CONFIG,
  payload: {
    config,
  },
});

/**
 * Update chat config (partial merge)
 */
export const updateChatConfig = config => ({
  type: types.UPDATE_CHAT_CONFIG,
  payload: {
    config,
  },
});

/**
 * Set persist chat data
 */
export const setPersistentChatData = persistentData => ({
  type: types.SET_PERSIST_CHAT_DATA,
  payload: {
    persistentData,
  },
});

/**
 * Toggle sound notifications
 */
export const toggleSoundNotifications = () => ({
  type: types.TOGGLE_SOUND_NOTIFICATIONS,
});
